import { render, staticRenderFns } from "./DefaultChart.vue?vue&type=template&id=4a33a89b&scoped=true"
import script from "./DefaultChart.vue?vue&type=script&lang=js"
export * from "./DefaultChart.vue?vue&type=script&lang=js"
import style0 from "./DefaultChart.vue?vue&type=style&index=0&id=4a33a89b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a33a89b",
  null
  
)

export default component.exports